d<template>
<!--  <div>-->

    <b-form-group>
      <label  v-html="fieldsData.label[selectlang]"></label>
<!--      {{fieldsData.id}}-->
  <b-form-checkbox-group
      v-model="selectedOptions"
            class="demo-inline-spacing checkbox-buttons "
            name="fieldsData.name"
            @input="UpdateValue($event)">
          <b-form-checkbox
              v-for="option in fieldsData['string-array']"
              :key="option.id"
              :value="option.id"
              class="checkbox-button btn btn-outline-primary" style="margin: 3px;">
            {{ option.title }}
          </b-form-checkbox>
        </b-form-checkbox-group>

<!--      <small class="text-danger" v-if="fieldsData.id==''">{{ fieldsData.error[selectlang] }}</small>-->
    </b-form-group>
<!--  </div>-->
</template>


<script>

// import {BFormCheckboxGroup, BFormCheckbox,} from 'bootstrap-vue';
export default {


  props: ['fieldsData','selectlang'],
  components: {
    //
    // BFormCheckboxGroup,
    // BFormCheckbox
  },
  data() {
    return {

      // errors: [],
      DataArray:{},

      selectedOptions:[],
    };
  },
  created() {

    if (this.fieldsData.id && this.fieldsData.id.length > 0) {
      // Split this.fieldsData.id into an array of integers
      this.selectedOptions= this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
     // this.fieldsData.id;
    }
//     if (this.fieldsData.id && this.fieldsData.id.length > 0) {
//       let idString = this.fieldsData.id; // '436, 1242'
//       let idArray = idString.split(',').map(Number); // [436, 1242]
//
// // Now assign the integer array back to this.fieldsData.id
//       this.fieldsData.id = idArray;
//       console.log(typeof this.fieldsData.id);
//
//       // this.selectedIds = this.fieldsData.id.split(',').map(id => id.trim());
//       // alert(this.selectedIds );
//
//       // alert(this.fieldsData.name);
//       // console.log(this.fieldsData);
//       // this.fieldsData.id  = this.fieldsData.id.map(id => parseInt(id));
//       // Split this.fieldsData.id into an array of integers
//
//    //    // this.fieldsData.find(item => item.name === this.fieldsData.name)["id"] = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
//    // console.log('shi', this.fieldsData.id);
//     }
    // this.fieldsData.id = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
  },

  methods: {
    isRequired(requiredValue) {
      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    UpdateValue(value) {
      // alert(value);
      const stringArray = this.fieldsData["string-array"];
      this.$emit('input', value)

// Check if any object in stringArray has a 'visible' key
      const hasVisibleKey = stringArray.some(item => 'visibleItem' in item);
      if(hasVisibleKey){
        const visibilityChanges = [];
        // const desiredItem = this.fieldsData['string-array'].find(item => item.id == value);
        let checkboxValues = this.fieldsData["string-array"].map(item => item.id);
        let selectedValues = value.filter(val => checkboxValues.includes(val));
        const selectname = this.fieldsData["string-array"].filter(item => selectedValues.includes(item.id));
        const visibleValues = selectname.map(item => item.visibleItem);
        let unselectedValues = checkboxValues.filter(val => !selectedValues.includes(val));
        const unselectname = this.fieldsData["string-array"].filter(item => unselectedValues.includes(item.id));
        const invisibleValues = unselectname.map(item => item.visibleItem);
        visibleValues.forEach(val => {
          visibilityChanges.push("show:" + val);
        });
// Push visibility changes for unselected values
        invisibleValues.forEach(val => {
          visibilityChanges.push("hide:" + val);
        });
        this.$emit('multifield',visibilityChanges);
      }
    },

  },
}
</script>


<style scoped>
.checkbox-buttons {
  display: flex;
  flex-wrap: wrap;
}


</style>
